import {type PropsWithChildren, useCallback} from 'react'
import {FiltersContext} from './FiltersContext'
import {ProjectId} from '@package/shared'
import {useSearchParams} from 'react-router-dom'
import dayjs from 'dayjs'
import {formatIsoDate} from '../../formatter/formatIsoDate.ts'
import type {DateRange} from '../../../../components/dateRangeSelector/DateRangeSelector.tsx'
import {useUserSettings} from '../../../../providers/userSettings/useUserSettings.ts'

export const FiltersProvider = ({children}: PropsWithChildren) => {
  useUserSettings()
  const [searchParams, setSearchParams] = useSearchParams()
  const startParam = searchParams.get('start') || undefined
  const week: DateRange = {
    start: dayjs(startParam).startOf('week'),
    end: dayjs(startParam).endOf('week'),
  }
  const projectId = searchParams.has('project') ? ProjectId.parse(searchParams.get('project')) : null

  const handleSetProjectId = useCallback(
    (projectId: ProjectId | null) => {
      setSearchParams((searchParams) => {
        if (projectId) searchParams.set('project', projectId)
        else searchParams.delete('project')

        return searchParams
      })
    },
    [setSearchParams],
  )

  const handleSetWeek = useCallback(
    (week: DateRange) => {
      setSearchParams((searchParams) => {
        if (week.start.isSame(dayjs().startOf('week'))) searchParams.delete('start')
        else searchParams.set('start', formatIsoDate(week.start))
        return searchParams
      })
    },
    [setSearchParams],
  )

  return (
    <FiltersContext.Provider
      value={{
        projectId,
        setProjectId: handleSetProjectId,
        week,
        setWeek: handleSetWeek,
      }}
    >
      {children}
    </FiltersContext.Provider>
  )
}
